import { ClientSafeFixKitViewV1Schema, FIX_KIT_DISCLAIMERS, FIX_KIT_SKU_PILOT, FixKitArtifactV1Schema, } from "../contracts/fix-kit.js";
import { FIX_KIT_NEXT_STEP_PROPOSAL, FIX_KIT_RECOMMENDATION_BY_CHECK_ID } from "./fix-kit-copy.js";
const leadPath = FIX_KIT_RECOMMENDATION_BY_CHECK_ID["surface-quality.lead-path-reachable"];
const schemaHints = FIX_KIT_RECOMMENDATION_BY_CHECK_ID["external-scan.schema-hints"];
/** Static sample artifact — no real tenant or live scan data; browser-safe (no node:crypto). */
export const SAMPLE_FIX_KIT_ARTIFACT = FixKitArtifactV1Schema.parse({
    schemaVersion: "fix-kit-artifact.v1.0",
    fixKitId: "fkit_sample_demo_only",
    claimId: "claim_sample_demo_only",
    publicReportRef: "rpt_sample_fixkit_demo",
    sku: FIX_KIT_SKU_PILOT,
    generatedAt: "2026-01-15T12:00:00.000Z",
    executiveSummary: "Fix Kit pilot for Report rpt_sample_fixkit_demo — score 62/100 (Needs attention). 2 prioritized remediation item(s) mapped from automated readiness checks.",
    items: [
        {
            issueRef: "surface-quality.lead-path-reachable",
            sourceCheckId: "surface-quality.lead-path-reachable",
            issueTitle: "Lead path may be hard to find for visitors.",
            issueDetail: "Lead path may be hard to find for visitors.",
            priority: leadPath.priority,
            recommendedFix: leadPath.recommendedFix,
            rationale: leadPath.rationale,
            clientFacingLanguage: leadPath.clientFacingLanguage,
            ownershipHint: leadPath.ownershipHint,
        },
        {
            issueRef: "external-scan.schema-hints",
            sourceCheckId: "external-scan.schema-hints",
            issueTitle: "Basic metadata signals are incomplete.",
            issueDetail: "Basic metadata signals are incomplete.",
            priority: schemaHints.priority,
            recommendedFix: schemaHints.recommendedFix,
            rationale: schemaHints.rationale,
            clientFacingLanguage: schemaHints.clientFacingLanguage,
            ownershipHint: schemaHints.ownershipHint,
        },
    ],
    nextStepProposal: FIX_KIT_NEXT_STEP_PROPOSAL,
    disclaimers: [...FIX_KIT_DISCLAIMERS],
    sourceScore: 62,
    sourceScoreLabel: "Needs attention",
    topIssuesSnapshot: [
        { title: "Contact and lead path", detail: "No obvious contact link was detected above the fold." },
        { title: "Metadata and structured data", detail: "Meta description is missing or too short." },
    ],
});
export function sampleClientSafeFixKitView() {
    return ClientSafeFixKitViewV1Schema.parse({
        schemaVersion: "client-safe-fix-kit-view.v1.0",
        title: "AI Readiness Fix Kit (sample)",
        executiveSummary: SAMPLE_FIX_KIT_ARTIFACT.executiveSummary,
        items: SAMPLE_FIX_KIT_ARTIFACT.items.map((item) => ({
            issueTitle: item.issueTitle,
            priority: item.priority,
            recommendedFix: item.recommendedFix,
            clientFacingLanguage: item.clientFacingLanguage,
        })),
        nextStepProposal: SAMPLE_FIX_KIT_ARTIFACT.nextStepProposal,
        disclaimers: SAMPLE_FIX_KIT_ARTIFACT.disclaimers,
    });
}
//# sourceMappingURL=sample-fix-kit.js.map